
import { defineComponent, PropType } from 'vue'
import { SeminarAttributes } from '@/types/models/seminar'

export default defineComponent({
  props: {
    seminarDetails: {
      type: Object as PropType<SeminarAttributes | undefined>,
      'default': () => (undefined),
    }
  },
})
